<template>
  <form class="dacb-name-form" autocomplete="off" @submit.prevent="submit">
    <label class="-name" for="name">{{ $t("enterName") }}:</label>
    <input
      id="name"
      v-model="name"
      class="-desktop"
      :class="{ '-error': touched && !valid }"
      type="text"
      :placeholder="[[name]]"
      @keyup="validate"
      @focus="inputFocus"
      @blur="inputBlur"
    />
    <input
      id="name"
      v-model="name"
      class="-mobile"
      :class="{ '-error': touched && !valid }"
      type="text"
      :placeholder="[[enterName]]"
      @keyup="validate"
      @focus="inputFocus"
      @blur="inputBlur"
    />

    <label class="-remember-me">
      <input v-model="rememberMe" type="checkbox" /><span>{{ $t("rememberMe") }}</span>
    </label>

    <div class="dacb-message-list">
      <div id="message-list-scrollable" class="dacb-scrollable">
        <div v-for="(field, index) in formFields" :key="`field-${index}`">
          <div v-if="field.type === 'message'" :ref="field.name" @click="sendMessage(field.name)">
            <div class="dacb-message dacb-suggested">
              <div class="dacb-text" :style="{ 'background-color': '#FFFFFF', color: '#494949' }">
                {{ field.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <input
      type="submit"
      :value="buttonText"
      :class="{ '-valid': valid }"
      :style="{ 'background-color': btnColour, color: btnTextColour }"
    />
  </form>
</template>

<script>
import { mapState } from "vuex";

import bus from "@/helpers/bus";
import validators from "@/helpers/validators";

export default {
  name: "NameForm",

  data() {
    return {
      touched: false,
      valid: false,
      name: this.$t("name"),
      enterName: this.$t("enterName"),
      rememberMe: true,
      buttonText: this.$t("startChat"),
      submitting: false,
      editableFields: []
    };
  },

  computed: {
    ...mapState({
      options: (state) => state.options.options,
      mobileMode: (state) => state.settings.mobileMode,
      browser: (state) => state.settings.browser,
      conversation: (state) => state.conversation.current,
      formFields: (state) => state.messages.formFields
    }),

    btnColour() {
      return this.options.primaryColour ? `${this.options.primaryColour} !important` : "#CBCBCB !important";
    },

    btnTextColour() {
      return `${this.options.textColour} !important`;
    }
  },

  methods: {
    validate() {
      this.valid = validators.validateName(this.name);
    },

    submit() {
      this.touched = true;
      if (!this.valid) return;
      if (this.submitting) return;

      this.buttonText = `${this.$t("pleaseWait")}...`;
      this.submitting = true;

      this.$store
        .dispatch("updateCustomerName", {
          name: this.name,
          conversation_id: this.conversation.id,
          remember: this.rememberMe
        })
        .catch((err) => {
          console.error("Error setting name", err);
        })
        .finally(() => {
          this.submitting = false;
          this.buttonText = this.$t("startChat");
        });
    },

    inputFocus() {
      if (this.name === this.$t("name") || this.name === this.$t("enterName")) {
        this.name = "";
      }
      bus.$emit("inputFocus");
    },

    inputBlur() {
      this.touched = true;
      bus.$emit("inputBlur");
    },

    sendMessage(message) {
      // Send a 'suggested question' directly
      this.touched = true;
      if (!this.valid) return;
      if (this.submitting) return;

      this.buttonText = "Please wait...";
      this.submitting = true;

      this.$store
        .dispatch("updateCustomerName", {
          name: this.name,
          conversation_id: this.conversation.id,
          remember: this.rememberMe,
          skip_response: true
        })
        .then(() => {
          // Send the message with a small delay to let the name request
          // complete first
          return new Promise((resolve) => {
            setTimeout(resolve, 250);
          }).then(() => {
            return this.$store.dispatch("createMessage", { content: message });
          });
        })
        .catch((err) => {
          console.error("Error setting name or sending first message", err);
        })
        .finally(() => {
          this.submitting = false;
          this.buttonText = this.$t("startChat");
        });
    }
  }
};
</script>
